{
  "completed": "Completed: ",
  "notCompleted": "Not completed: ",
  "current": "Current: ",
  "steplist": "Step List"
}
